import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
	selector: 'app-list-status',
	templateUrl: './list-status.component.html',
	styleUrls: ['./list-status.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class ListStatusComponent {
	@Input()
	public data: Array<any> = [];

	@Input()
	public requesting: boolean = false;
}
